import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import BaseLayout from '@/components/layout/BaseLayout';
import SalesDashboard from './pages/SalesDashboard';
import SalesProfile from './pages/SalesProfile';
import CustomerManagement from './pages/CustomerManagement';
// import ContractManagement from './pages/ContractManagement';
import InventoryManagement from './pages/InventoryManagement';
import OrderManagement from './pages/OrderManagement';
// import VoiceInvoicing from './pages/VoiceInvoicing';
// import PaymentTracking from './pages/PaymentTracking';
// import DeliveryScheduling from './pages/DeliveryScheduling';
// import PriceBenchmarking from './pages/PriceBenchmarking';
// import ComplianceReports from './pages/ComplianceReports';
// US-BATCH-005: Available Batches
// import AvailableBatchesPage from '@/pages/inventory/AvailableBatchesPage';
// US-ORD-004: Order Details
import OrderDetailsPage from '@/pages/commerce/OrderDetailsPage';
// US-ORD-001: Create Order
import CreateOrderPage from '@/pages/commerce/CreateOrderPage';
// Delivery Management integration
import DeliveryManagement from '@/pages/commerce/delivery/DeliveryManagement';
import NewDeliveryRequest from '@/pages/commerce/delivery/NewDeliveryRequest';
import DeliveryDetailPage from '@/pages/commerce/delivery/DeliveryDetailPage';
import DeliveryEditPage from '@/pages/commerce/delivery/DeliveryEditPage';
// Marketplace: My Products integration
import { MyProductsPage } from '@/modules/marketplace/pages/MyProductsPage';
import { AddProductPage } from '@/modules/marketplace/pages/AddProductPage';
import { EditProductPage } from '@/modules/marketplace/pages/EditProductPage';
import { ViewProductPage } from '@/modules/marketplace/pages/ViewProductPage';
// Marketplace: Inquiries integration
import { InquiryInboxPage } from '@/modules/marketplace/pages/InquiryInboxPage';
import {
  LayoutDashboard,
  Users,
  FileText,
  Package,
  ShoppingCart,
  Mic,
  CreditCard,
  Truck,
  TrendingUp,
  Shield,
  Store,
  MessageSquare
} from 'lucide-react';

const SalesModule: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    {
      id: 'dashboard',
      label: 'Sales Dashboard',
      icon: <LayoutDashboard className="w-5 h-5" />,
      onClick: () => navigate('/sales'),
      isActive: location.pathname === '/sales'
    },
    {
      id: 'customers',
      label: 'Customer Management',
      icon: <Users className="w-5 h-5" />,
      onClick: () => navigate('/sales/customers'),
      isActive: location.pathname === '/sales/customers'
    },
    // {
    //   id: 'contracts',
    //   label: 'Contract Management',
    //   icon: <FileText className="w-5 h-5" />,
    //   onClick: () => navigate('/sales/contracts'),
    //   isActive: location.pathname === '/sales/contracts'
    // },
    {
      id: 'inventory',
      label: 'Inventory Management',
      icon: <Package className="w-5 h-5" />,
      onClick: () => navigate('/sales/inventory'),
      isActive: location.pathname === '/sales/inventory'
    },
    {
      id: 'my-products',
      label: 'My Products',
      icon: <Store className="w-5 h-5" />,
      onClick: () => navigate('/sales/my-products'),
      isActive: location.pathname === '/sales/my-products' || location.pathname.startsWith('/marketplace/seller/products')
    },
    {
      id: 'inquiries',
      label: 'Inquiries',
      icon: <MessageSquare className="w-5 h-5" />,
      onClick: () => navigate('/sales/inquiries'),
      isActive: location.pathname === '/sales/inquiries' || location.pathname.startsWith('/marketplace/seller/inquiries')
    },
    // {
    //   id: 'available-batches',
    //   label: 'Available Batches',
    //   icon: <Package className="w-5 h-5" />,
    //   onClick: () => navigate('/sales/available-batches'),
    //   isActive: location.pathname === '/sales/available-batches'
    // },
    {
      id: 'orders',
      label: 'Order & Invoice',
      icon: <ShoppingCart className="w-5 h-5" />,
      onClick: () => navigate('/sales/orders'),
      isActive: location.pathname === '/sales/orders'
    },
    // {
    //   id: 'delivery',
    //   label: 'Delivery Management',
    //   icon: <Truck className="w-5 h-5" />,
    //   onClick: () => navigate('/sales/delivery'),
    //   isActive: location.pathname === '/sales/delivery' || location.pathname.startsWith('/sales/delivery/')
    // },
    // {
    //   id: 'voice-invoice',
    //   label: 'Voice Invoicing',
    //   icon: <Mic className="w-5 h-5" />,
    //   onClick: () => navigate('/sales/voice-invoice'),
    //   isActive: location.pathname === '/sales/voice-invoice'
    // },
    // {
    //   id: 'payments',
    //   label: 'Payment Tracking',
    //   icon: <CreditCard className="w-5 h-5" />,
    //   onClick: () => navigate('/sales/payments'),
    //   isActive: location.pathname === '/sales/payments'
    // },
    // {
    //   id: 'pricing',
    //   label: 'Price Benchmarking',
    //   icon: <TrendingUp className="w-5 h-5" />,
    //   onClick: () => navigate('/sales/pricing'),
    //   isActive: location.pathname === '/sales/pricing'
    // },
    // {
    //   id: 'compliance',
    //   label: 'Compliance & Reports',
    //   icon: <Shield className="w-5 h-5" />,
    //   onClick: () => navigate('/sales/compliance'),
    //   isActive: location.pathname === '/sales/compliance'
    // }
  ];

  return (
    <BaseLayout
      moduleName="UrjaVyapar Sales"
      moduleSubtitle="Comprehensive Sales Management System"
      navigationItems={navigationItems}
      userInfo={{
        name: "Sales Manager",
        role: "Sales Operations"
      }}
    >
      <Routes>
        <Route path="/" element={<SalesDashboard />} />
        <Route path="/profile" element={<SalesProfile />} />
        <Route path="/customers" element={<CustomerManagement />} />
        {/* <Route path="/contracts" element={<ContractManagement />} /> */}
        <Route path="/inventory" element={<InventoryManagement />} />
        <Route path="/my-products" element={<MyProductsPage title="My Products" disableLayout={true} />} />
        <Route path="/my-products/add" element={<AddProductPage disableLayout={true} />} />
        <Route path="/my-products/view/:productId" element={<ViewProductPage disableLayout={true} />} />
        <Route path="/my-products/:productId/edit" element={<EditProductPage disableLayout={true} />} />
        <Route path="/inquiries" element={<InquiryInboxPage disableLayout={true} />} />
        {/* <Route path="/available-batches" element={<AvailableBatchesPage />} /> */}
        <Route path="/orders" element={<OrderManagement />} />
        <Route path="/orders/new" element={<CreateOrderPage />} />
        <Route path="/orders/:orderId" element={<OrderDetailsPage />} />
        <Route path="/delivery" element={<DeliveryManagement />} />
        <Route path="/delivery/new" element={<NewDeliveryRequest />} />
        <Route path="/delivery/:id" element={<DeliveryDetailPage />} />
        <Route path="/delivery/:id/edit" element={<DeliveryEditPage />} />
        {/* <Route path="/voice-invoice" element={<VoiceInvoicing />} /> */}
        {/* <Route path="/payments" element={<PaymentTracking />} /> */}
        {/* <Route path="/pricing" element={<PriceBenchmarking />} /> */}
        {/* <Route path="/compliance" element={<ComplianceReports />} /> */}
      </Routes>
    </BaseLayout>
  );
};

export default SalesModule;